import Entity from './Entity';

export default class BackgroundWeather implements Entity {
  constructor(public id: number, public name: string) {}
}
